import { slice } from './slice';

const { reducer, actions } = slice;

export const { reset: resetJackpot } = actions;

export * from './thunks';
export * from './actions';
export * as jackpotSelectors from './selectors';

export default reducer;
